/* eslint-disable react/prop-types */
import { FormattedMessage } from 'react-intl';

import commonTranslations from 'shared/translations/overlay-common-translations';
import { availableVideoType, AVAILABLE_VIDEO_TYPES } from 'widget/ui-selectors/video-access';


export const DEFAULT_TRANSLATIONS = {
  [AVAILABLE_VIDEO_TYPES.FULL]: commonTranslations.playVideo,
  [AVAILABLE_VIDEO_TYPES.TRAILER]: commonTranslations.watchTrailer,
  [AVAILABLE_VIDEO_TYPES.FIRST_20_SEC]: commonTranslations.watchPreview,
};


/**
 * Is channel play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video, currentSiteUser }) {
  return Boolean(availableVideoType(channel, video, currentSiteUser));
}

/**
 * Channel play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
export default function renderPlayButtonText({ channel, video, currentSiteUser, translations = DEFAULT_TRANSLATIONS }) {
  const type = availableVideoType(channel, video, currentSiteUser);

  if (!type) {
    return null;
  }
  return <FormattedMessage {...translations[type]} />;
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/video/play-button-text.js